import type { UserDetail } from '@src/dto/UserManagement';
import { Store } from '@tanstack/react-store';
import type { SortingState } from '@tanstack/react-table';
import { createManagementActions } from './createManagementStore';

interface UserManagementState {
  users: UserDetail[];
  filters: {
    role: string;
    onboardingState: string;
    emailVerified: string;
    search: string;
  };
  sorting: SortingState;
  pagination: {
    currentPage: number;
    totalPages: number;
    total: number;
  };
  ui: {
    isLoading: boolean;
    selectedUserId: string | null;
    roleChangeModalOpen: boolean;
  };
}

const initialFilters: UserManagementState['filters'] = {
  role: 'all',
  onboardingState: 'all',
  emailVerified: 'all',
  search: '',
};

const defaultSorting: SortingState = [{ id: 'created', desc: true }];

export const userManagementStore = new Store<UserManagementState>({
  users: [],
  filters: initialFilters,
  sorting: defaultSorting,
  pagination: { currentPage: 1, totalPages: 1, total: 0 },
  ui: { isLoading: true, selectedUserId: null, roleChangeModalOpen: false },
});

const actions = createManagementActions(userManagementStore, {
  initialFilters,
  defaultSorting,
});

export const {
  updateFilter,
  setSorting,
  setPage,
  setPaginationInfo,
  setLoading,
} = actions;

export const setUsers = (users: UserDetail[]) => {
  userManagementStore.setState((prev) => ({ ...prev, users }));
};

export const selectUser = (userId: string | null) => {
  actions.setUiField('selectedUserId', userId);
};

export const setRoleChangeModalOpen = (isOpen: boolean) => {
  actions.setUiField('roleChangeModalOpen', isOpen);
};
